import React, { useState } from "react";
import { Helmet } from "react-helmet";
import { Text } from "../../components/ui/text"
import Header from "../../components/layout/header";
import { Link } from "react-router-dom";
import DashboardPage from "./dashboard/page";
import UsersPage from "./details/page";
import { getStore } from "../../utils/functions"
import { useLayoutEffect } from "react"
import { useNavigate } from "react-router-dom"

const Home = () => {
  const navigate = useNavigate()
  const auth = getStore("auth")
  const [activeTab, setActiveTab] = useState("Dashboard");

  const handleTabClick = (tabName) => {
    setActiveTab(tabName);
  };

  useLayoutEffect(() => {
    if (!auth?.email) {
      navigate("/login")
    }
  }, [])

  const props = {
    user:auth
  }

  if (auth?.email)
    return (
      <>
        <Helmet>
          <title>Panel</title>
          <meta name="description" content="Web site created using create-react-app" />
        </Helmet>
        <div className="w-full pb-8 sm:pb-5 bg-gray-100_01">
          <Header {...props} />
          <div>
            <div className="flex flex-col gap-6">
              <div className="flex flex-col items-start border-gray-200 border-b border-solid bg-white-A700">
                <div className="flex flex-col w-[15%] md:w-full mt-[21px] ml-[31px] gap-[17px] md:ml-0">
                  <div className="flex justify-between gap-5">
                    <div className="flex justify-center w-[50%]" onClick={() => handleTabClick("Dashboard")}>
                      <Text size="lg" as="p" className={activeTab === "Dashboard" ? "!text-green-400" : "!text-gray-900_7e !font-normal opacity-0.4"}>
                        Dashboard
                      </Text>
                    </div>
                    <div className="flex justify-center w-[31%]" onClick={() => handleTabClick("Details")}>
                      <Text size="lg" as="p" className={activeTab === "Details" ? "!text-green-400" : "!text-gray-900_7e !font-normal opacity-0.4"}>
                        Details
                      </Text>
                    </div>
                  </div>
                  <div className="h-[4px] rounded-tl-sm rounded-tr-sm bg-green-400" style={{ width: activeTab === "Dashboard" ? "49%" : "31%", marginLeft: activeTab === "Dashboard" ? "0" : "70%" }} />
                </div>
              </div>
              {activeTab === "Dashboard" && (
                <DashboardPage />
              )}
              {activeTab === "Details" && (
                <UsersPage />
              )}
            </div>
          </div>
        </div>
      </>
    );
};

export default Home;
